import React from 'react'
import ServerSelect from 'App/components/fields/ServerSelect'
import gql from 'graphql-tag'

export default function WebsitesIds(props) {
  return (
    <ServerSelect
      {...props}
      multi={props.multi !== false} // undefined es true
      cleanValue={item => ({
        value: item._id,
        label: item.name,
        website: item
      })}
      searchQuery={gql`
        query getWebsites($filter: String) {
          searchItems: websites(limit: 10, filter: $filter) {
            _id
            items {
              _id
              name
            }
          }
        }
      `}
      valuesQuery={gql`
        query getWebsites($valuesIds: [ID]) {
          values: websitesByIds(websitesIds: $valuesIds) {
            _id
            name
          }
        }
      `}
    />
  )
}
